/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { gsapAnimations } from "./partials/gsapAnimations.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { chart } from "./partials/chart.js";
import { lottieAnimation } from "./partials/lottieAnimations.js";
import { slider } from "./partials/slider.js";
import { panel } from "./partials/panel.js";
import { pageScroll } from "./partials/pageScroll.js";
import { menu } from "./partials/menu.js";
import { header } from "./partials/header.js";
import { hoverEffects } from "./partials/hoverEffects.js";
import { highlightBox } from "./partials/highlightBox.js";
import { map2024 } from "./partials/map2024.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if (formSubmittedElement) {
        window.scrollTo(0, formSubmittedElement.closest('.form-item').offsetTop);
    }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click', e => {
        document.querySelector('#mainContent').focus();
    });

    intersectionObservation();
    gsapAnimations();
    modal(body, bodyLoadingClass);
    slider();
    video();
    cookies();
    chart();
    lottieAnimation();
    panel();
    menu();
    header();
    pageScroll();
    hoverEffects();
    highlightBox();
    map2024();
});
